import {isArrayNullUndefinedOrEmpty} from "../../../services/Validator";
import SystemScreenError from "../../errors/SystemScreenError";
import {kSystemGradesError} from "../../../constants/errors";
import CoursesSubthemesContent from "./CoursesSubthemesContent";
import {
    GradePickerSize
} from "../../../controllers/flashScreens/parameterStepScreen/ParameterGradeBadgeItemController";
import CoursesGradesList from "../../lists/courses/CoursesGradesList";

export default function CoursesCoreContent({ grades,
                                selectedGrade,
                                setFlashGrade,
                                isSubthemesLoading,
                                subthemesError,
                                subthemes,
                                selectSubtheme,
                                selectedSubtheme,
                                levelAs,
                                selectedLevelAs,
                                pickLevelA,
                                clearLevelAs,
                                // ---- Flash
                                isFlashLoading,
                                fetchFlashQuestions,
                                // ---- Exerciser
                                isExerciserLoading,
                                fetchExerciserProblem }) {
    // Used in CoursesScreen to display both
    // Grade and Subthemes pickers

    // BUILD
    if (isArrayNullUndefinedOrEmpty(grades))
        return <SystemScreenError error={kSystemGradesError} />
    return (
        <div className={"overflow-auto w-full grow h-[520px] min-h-[480px] max-h-[640px] flex flex-col"}>
            <CoursesGradesList grades={grades}
                               selectedGrade={selectedGrade}
                               setFlashGrade={setFlashGrade}
                               gradePickerSize={GradePickerSize.MEDIUM}
                               extraClass={"mt-[24px]"} />
            <CoursesSubthemesContent selectedGrade={selectedGrade}
                                     isSubthemesLoading={isSubthemesLoading}
                                     subthemesError={subthemesError}
                                     subthemes={subthemes}
                                     selectSubtheme={selectSubtheme}
                                     selectedSubtheme={selectedSubtheme}
                                     levelAs={levelAs}
                                     pickLevelA={pickLevelA}
                                     clearLevelAs={clearLevelAs}
                                     selectedLevelAs={selectedLevelAs}
                                     // ---- Flash
                                     fetchFlashQuestions={fetchFlashQuestions}
                                     isFlashLoading={isFlashLoading}
                                     // ---- Exerciser
                                     isExerciserLoading={isExerciserLoading}
                                     fetchExerciserProblem={fetchExerciserProblem} />
        </div>
    );
}